import Agent from '../Core/agent';

const headers = {
    headers: {
        'Content-Type': 'application/json;'
    }
};

const FilterAPi = {
    search: async data => {
        return Agent.post(
            '/api/filter/search',
             JSON.stringify(data),
            headers
        );
    },
    searchDisable: async data =>{
        return Agent.post(
            '/api/filter/search_disable',
            JSON.stringify(data),
            headers
        );
    }
};
export default FilterAPi;